module.exports = __webpack_public_path__ + "static/img/claimed_yes.5e2a33ec.svg";